import Glide from '@glidejs/glide';

class Dictionary {
  constructor() {
    this.defaultLetter = 'A';
    this.alphabet_events_set = false;
    this.setupAlphabet();
  }

  setupAlphabet( current_letter = null ) {
    if( null == current_letter ) {
      current_letter = this.defaultLetter;
    }

    const alphabet_section = document.querySelector("ul.cd-main__list");
    let list_str = '';

    if( null == alphabet_section ){
      return;
    }
    
    let active = '';
    for( var key in dictionary_data ) {
      if( key === current_letter ) {
        active = 'active';
      } else {
        active = '';
      }
      list_str += `<li class="cd-main__list-item glide__slide ${active}">
      <a href="#" data-letter="${key}">${key}</a>
  </li>`;
    }

    alphabet_section.innerHTML = list_str;

    this.getDictionaryInfo( current_letter );

    if( !this.alphabet_events_set ) {
      this.loadAlphabetEvents();
    }
    this.loadContentEvents();

    this.glide  = new Glide('.glide', {
      type: 'slider',
      perView: 20,
      focusAt: 0,
      rewind: false,
      breakpoints: {
        1176: {
          perView: 12
        },
        800: {
          perView: 8
        },
        600: {
          perView: 6
        },
        480: {
          perView: 4
        }
      }
    })

    this.glide.on('move', function(move) {
      var slides = document.querySelectorAll('.glide__slide').length;
      if(document.querySelector('.glide__slides').clientWidth <= (document.querySelector('.glide__track').clientWidth+1)){
        if(move.movement>0){
          console.log('a')
          document.querySelector(".glide__arrow--prev").classList.remove('disabled');
          document.querySelector(".glide__arrow--prev").disabled = false;
        }else{
          console.log('b')
          document.querySelector(".glide__arrow--prev").classList.add('disabled');
          document.querySelector(".glide__arrow--prev").disabled = true;
        }
        if((slides*Number(document.querySelectorAll('.glide__slide')[0].clientWidth)-move.movement) <= document.querySelector('.glide__track').clientWidth){
          console.log('c')
          document.querySelector(".glide__arrow--next").classList.add('disabled');
          document.querySelector(".glide__arrow--next").disabled = true;
        }else{
          console.log('d')
          document.querySelector(".glide__arrow--next").classList.remove('disabled');
          document.querySelector(".glide__arrow--next").disabled = false;
        }
      }else if(move.movement==0){
        document.querySelector(".glide__arrow--prev").classList.add('disabled');
        document.querySelector(".glide__arrow--prev").disabled = true;
        document.querySelector(".glide__arrow--next").classList.remove('disabled');
        document.querySelector(".glide__arrow--next").disabled = false;
      }else if((slides*Number(document.querySelectorAll('.glide__slide')[0].clientWidth)-move.movement) <= document.querySelector('.glide__track').clientWidth){
        document.querySelector(".glide__arrow--next").classList.add('disabled');
        document.querySelector(".glide__arrow--next").disabled = true;
        document.querySelector(".glide__arrow--prev").classList.remove('disabled');
        document.querySelector(".glide__arrow--prev").disabled = false;
      }else{
        document.querySelector(".glide__arrow--prev").classList.remove('disabled');
        document.querySelector(".glide__arrow--next").classList.remove('disabled');
        document.querySelector(".glide__arrow--next").disabled = false;
        document.querySelector(".glide__arrow--prev").disabled = false;
      }
    })
    this.glide.mount()
  }

  getDictionaryInfo( current_letter = null ) {
    if( null == current_letter ) {
      current_letter = this.defaultLetter;
    }

    const dictionary_section = document.querySelector("div.dictionary__list .cd-secondary__list");
    
    if( null != dictionary_section && "undefined" != typeof dictionary_data ){
      let dictionary_str = '';
      
      for( var key in dictionary_data[current_letter] ) {
				var item = dictionary_data[current_letter][key];

        dictionary_str += `<li class="cd-secondary__list-item">
            <a class="link" href="#" data-description="${item.description}">${item.title}</a>
        </li>`;
			}
      dictionary_section.innerHTML = dictionary_str;
      
      this.loadWordsEvents();
    }
  }

  showDescription( description ) {
    document.querySelector("div.cd-featured-content").classList.add('hide');
    document.querySelector("div.cd-description").classList.remove('hide');
    document.querySelector("div.cd-description__content").innerHTML = description;

  }

  loadAlphabetEvents() {
    var _self = this;
		//Add event listener to dictionary letters list
		var letters_links = document.querySelectorAll("li.cd-main__list-item a");
		for( var i = 0; i < letters_links.length; i++ ){
			letters_links[i].addEventListener('click', event => {
        event.preventDefault();
        for( var j = 0; j < letters_links.length; j++ ){
          letters_links[j].parentNode.classList.remove('active');
        }
        event.target.parentNode.classList.add('active');
				_self.getDictionaryInfo( event.target.dataset.letter );
			});
    }
    
		this.alphabet_events_set = true;
  }

  loadWordsEvents() {
    var _self = this;
		//Add event listener to dictionary letters list
		var words_links = document.querySelectorAll("li.cd-secondary__list-item a");
		for( var i = 0; i < words_links.length; i++ ){
			words_links[i].addEventListener('click', event => {
        event.preventDefault();
				_self.showDescription( event.target.dataset.description );
			});
    }
  }

  loadContentEvents() {
    document.querySelector("div.cd-description a").addEventListener('click', event => {
      event.target.parentNode.classList.add('hide');
      document.querySelector("div.cd-featured-content").classList.remove('hide');
    });
  }
}

export default Dictionary
